import "./data-entry-step1.scss";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { MIN_PERIOD } from "src/config";
import { atomPolicy, atomQuestionnaire } from "src/storage";
import { Formik, FormikInsurance, PeriodType } from "src/types";
import { addStartDays, formatDate, reverseDate } from "src/utils";

export const useDataEntryStep1 = ({
  formik,
}: {
  formik: Formik<FormikInsurance>;
}) => {
  const { t } = useTranslation();
  const {
    values: { coverageStartDate, insuredDaysNumber, insuredPeriodType },
    errors: { insuredDaysNumber: insuredDaysNumberError },
    setFieldValue,
  } = formik;

  const policy = useRecoilValue(atomPolicy);
  const questionnaire = useRecoilValue(atomQuestionnaire);
  const resetPolicy = useResetRecoilState(atomPolicy);
  const resetQuestionnaire = useResetRecoilState(atomQuestionnaire);

  useEffect(() => {
    if (policy) resetPolicy();
    if (questionnaire) resetQuestionnaire();
  }, []);

  //Sets appropriate value when the user switches the coverage package type
  const onSelectPackage = (value: string) => {
    setFieldValue("coverageTypeRadios", value);
  };

  // Force coverageEndDate and insuredPeriodType based on insuredDaysNumber changes
  useEffect(() => {
    if (insuredDaysNumberError || Number(insuredDaysNumber) < MIN_PERIOD)
      return;

    const calculatedEndDate = addStartDays(
      reverseDate(coverageStartDate),
      Number(insuredDaysNumber) - 1
    );
    setFieldValue("coverageEndDate", formatDate(calculatedEndDate));

    let newInsuredPeriodType = PeriodType.DAILY;
    if (Number(insuredDaysNumber) > 1) newInsuredPeriodType = PeriodType.PERIOD;

    if (newInsuredPeriodType === insuredPeriodType) return;

    setFieldValue("insuredPeriodType", newInsuredPeriodType);
  }, [insuredDaysNumber, insuredDaysNumberError]);

  return {
    MIN_PERIOD,
    t,
    onSelectPackage,
  };
};
